export default __webpack_public_path__ + "75a38e49bc14dcac6c4b051f77169538.svg";